import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
// This file has been generated using @svgr/cli.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.63 43c6.472 0 11.883-.683 16.228-2.04a2 2 0 0 0 1.376-2.237l-.843-5.073a5 5 0 0 0-4.501-4.161C32.128 29.163 28.042 29 23.63 29c-4.41 0-8.497.163-12.258.489a5 5 0 0 0-4.5 4.161l-.845 5.073a2 2 0 0 0 1.377 2.237C11.75 42.317 17.16 43 23.631 43Zm0 2c-6.659 0-12.265-.708-16.822-2.13a4 4 0 0 1-2.753-4.475l.843-5.073a7 7 0 0 1 6.301-5.826c3.822-.33 7.965-.496 12.432-.496 4.466 0 8.61.165 12.431.497a7 7 0 0 1 6.301 5.825l.844 5.073a4 4 0 0 1-2.753 4.474C35.897 44.292 30.29 45 23.63 45Zm-8-32a8 8 0 0 0 8 8 8 8 0 0 0 8-8 8 8 0 0 0-8-8 8 8 0 0 0-8 8Zm-2 0c0-5.523 4.477-10 10-10 5.524 0 10 4.476 10 10 0 5.523-4.476 10-10 10-5.522 0-10-4.476-10-10Z",
    fill: "currentColor"
  }));
};

var SvgUser = styled(SvgComponent).withConfig({
  displayName: "User__SvgUser",
  componentId: "sc-1rxywiq-0"
})(["", " ", ""], size, color);
export default SvgUser;